module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="message">\n    <h3 id="title">' +
((__t = ( I18n.t('uploader.confirmation.thanks') )) == null ? '' : __t) +
'</h3>\n    <p id="primary">' +
((__t = ( I18n.t('uploader.confirmation.submitted') )) == null ? '' : __t) +
'</p>\n    <p id="secondary">' +
((__t = ( I18n.t('uploader.confirmation.check_back') )) == null ? '' : __t) +
'</p>\n</div>\n<div class="bottom_button">\n    ';
 if (redirect_url) { ;
__p += '\n        <a id="redirect" class="confirm_button" href="' +
((__t = ( redirect_url )) == null ? '' : __t) +
'" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( I18n.t('uploader.confirmation.finish') )) == null ? '' : __t) +
'</a>\n    ';
 } else { ;
__p += '\n        <button id="finish" class="confirm_button" type="button">' +
((__t = ( I18n.t('uploader.confirmation.finish') )) == null ? '' : __t) +
'</button>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}